import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=7a4a6ef0&"
import script from "./Wave.vue?vue&type=script&lang=ts&"
export * from "./Wave.vue?vue&type=script&lang=ts&"
import style0 from "./Wave.vue?vue&type=style&index=0&id=7a4a6ef0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports